import { render } from "./liveStatement.vue?vue&type=template&id=2ce376ba"
import script from "./liveStatement.vue?vue&type=script&lang=js"
export * from "./liveStatement.vue?vue&type=script&lang=js"

import "./liveStatement.vue?vue&type=style&index=0&id=2ce376ba&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__